export default __webpack_public_path__ + "static/media/Cloak of the Shivering Stars.d3d8d99e.jpg";